import React from "react";
import { ProductReviewDetail } from "../../reviewModels";

interface ReviewMultipleVariantDetailsProps {
  review: ProductReviewDetail;
}

const ReviewMultipleVariantDetails = ({
  review,
}: ReviewMultipleVariantDetailsProps) => {
  return (
    <div className="flex flex-col gap-0.5">
      {review.variations?.map((variation) => (
        <div key={variation.type}>
          <dl className="flex m-0">
            <dt className="font-bold inline-block">{variation.type}:</dt>
            <dd className="ml-1 inline-block">{variation.value}</dd>
          </dl>
        </div>
      ))}
    </div>
  );
};

export default ReviewMultipleVariantDetails;
